<template>
    <v-dialog @input="(!$event)? $payments.show = false : null" :width="($vuetify.breakpoint.mdAndUp)? '70%' : '95%'" :value="$payments.show">
        <v-card>
            <v-card-title>{{$t('Your payment requests')}}</v-card-title>
            <v-card-text>
                <div class="d-flex flex-wrap">
                    <v-checkbox @change="$payments.selected = []" :label="$t('Already requested')" v-model="$payments.filters.is_request"></v-checkbox>
                    <v-checkbox @change="$payments.selected = []" class="ml-2" true-value="1" false-value="0" :label="$t('Show done')" v-model="$payments.filters.done"></v-checkbox>
                </div>
                <v-data-table  show-select v-if="$payments.data" :headers="headers" v-model="$payments.selected" :items="$payments.filteredWebsite">
                    <template v-slot:item.link="{item}">
                        <a class="default-link" :href="item.link">Link</a>
                    </template>
                </v-data-table>
                <v-btn @click="makePaymentRequest()" v-if="$payments.selected.length > 0 && $payments.filters.done == false && $payments.filters.is_request == false" color="secondary" dark>{{$t('Make payment request')}}</v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    import Vue from 'vue';
    import Payments from '../../plugins/payment'
    export default {
        data:() => {
            return{
                type:'main',
                loading:false,
                tab: 0,
                original_headers:[{
                    text: 'ID',
                    value: 'id',
                    sortable: true
                },{
                    text: 'Order id',
                    value: 'order_id',
                    sortable: true
                },{
                    text: 'Email',
                    value: 'order.email',
                    sortable: true
                },{
                    text: 'Amount',
                    value: 'amount_for_website',
                    type: 'amount',
                    sortable: true
                }]
            }
        },
        computed:{
              headers(){
                  var data = this.original_headers;
                  if(this.$payments.filters.is_request || this.$payments.filters.done){
                      data = [...data, {text: 'Link', value: 'link', sortable: true}];
                  }
                  return data;
              }
        },
        watch:{
            tab:function () {
                this.headers.forEach((item, index) => {
                    this.$payments.selected = [];
                    if(item.type == 'amount'){
                        if(this.tab == 0){
                            this.headers[index].text = 'Amount for website';
                            this.headers[index].value= 'amount_for_website';
                        }
                        if(this.tab == 1){
                            this.headers[index].text = 'Amount for Visual Impression';
                            this.headers[index].value= 'amount_for_vi';
                        }
                    }
                })
            }
        },
        methods:{
          makePaymentRequest(){
              this.loading = true;
              this.$payments.makePaymentRequest().then(res => {
                  this.loading = false;
              });
          }
        },
        created() {
            Vue.prototype.$payments = new Vue(Payments);
        }
    }
</script>
